import { Injectable } from '@angular/core';
import { AppMetadataHandler } from '../../configs/app-metadata.handler'

@Injectable()
export class numberUtil {

  constructor(public appMetadataHandler: AppMetadataHandler) { }

  formatterPercent = value => `${value || 0} %`;
  parserPercent = value => value.replace(' %', '');
  
}
